// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28759":"34ad6e17","82471":"54e976bb","93406":"e88c5889"}[chunkId] + ".chunk.css";
};